import { FC, SVGProps } from 'react'

export type FlagIcon = FC<SVGProps<SVGSVGElement>>
export const UzFlag: FlagIcon = (props) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0.37775 5.56525C0.132688 6.333 -3.12445e-05 7.1509 5.51734e-09 7.99993C-3.12445e-05 8.849 0.132719 9.66697 0.377781 10.4347L8 10.7826L15.6222 10.4348C15.8673 9.667 16 8.849 16 8C16 7.15093 15.8673 6.333 15.6222 5.56522L8 5.2174L0.37775 5.56525Z'
      fill='#F0F0F0'
    />
    <path
      d='M15.622 5.56525L7.99975 5.21744L0.377504 5.56525C0.304546 5.79419 0.241961 6.02632 0.189941 6.26091H15.8094C15.7575 6.02631 15.6949 5.79418 15.622 5.56525ZM0.190035 9.73909C0.242005 9.97368 0.304569 10.2058 0.377535 10.4347L0.378285 10.4348L7.99972 10.7826L15.6219 10.4348C15.6949 10.2058 15.7575 9.97369 15.8095 9.73909H0.190035Z'
      fill='#D80027'
    />
    <path
      d='M8.00012 16C11.5694 16 14.5922 13.6624 15.6223 10.4347H0.37793C1.40809 13.6623 4.43096 16 8.00012 16Z'
      fill='#6DA544'
    />
    <path
      d='M8.00015 3.05179e-05C4.43096 6.17679e-05 1.40815 2.33766 0.37793 5.56525L15.6223 5.56528C14.5922 2.33762 11.5694 -7.3211e-07 8.00015 3.05179e-05Z'
      fill='#338AF3'
    />
    <path
      d='M3.65568 3.30437C3.65568 2.55509 4.18227 1.92916 4.88549 1.77559C4.77532 1.75143 4.66287 1.73923 4.55008 1.73919C3.68564 1.73919 2.98486 2.43994 2.98486 3.30441C2.98486 4.16887 3.68558 4.86962 4.55008 4.86962C4.66527 4.86962 4.77739 4.85681 4.88549 4.83322C4.1823 4.67959 3.65568 4.05366 3.65568 3.30437ZM5.81061 4.01584L5.91655 4.34194H6.25943L5.98205 4.5435L6.08799 4.86959L5.81061 4.66806L5.53318 4.86959L5.63914 4.5435L5.36174 4.34194H5.70461L5.81061 4.01584ZM6.90499 4.01584L7.01096 4.34194H7.35383L7.07643 4.5435L7.18239 4.86959L6.90499 4.66806L6.62758 4.86959L6.73355 4.5435L6.45618 4.34194H6.79902L6.90499 4.01584ZM7.99939 4.01584L8.10533 4.34194H8.44824L8.17083 4.5435L8.27677 4.86959L7.99939 4.66806L7.72196 4.86959L7.82796 4.5435L7.55052 4.34194H7.89343L7.99939 4.01584ZM9.0938 4.01584L9.19977 4.34194H9.54261L9.26524 4.5435L9.37121 4.86959L9.0938 4.66806L8.81636 4.86959L8.92236 4.5435L8.64493 4.34194H8.9878L9.0938 4.01584ZM10.1882 4.01584L10.2941 4.34194H10.637L10.3596 4.5435L10.4656 4.86959L10.1882 4.66806L9.91077 4.86959L10.0167 4.5435L9.73936 4.34194H10.0822L10.1882 4.01584ZM6.90499 2.8775L7.01096 3.20356H7.35383L7.07643 3.40516L7.18239 3.73122L6.90499 3.52969L6.62758 3.73122L6.73355 3.40516L6.45618 3.20356H6.79902L6.90499 2.8775ZM7.99939 2.8775L8.10533 3.20356H8.44824L8.17083 3.40516L8.27677 3.73122L7.99939 3.52969L7.72196 3.73122L7.82796 3.40516L7.55052 3.20356H7.89343L7.99939 2.8775ZM9.0938 2.8775L9.19977 3.20356H9.54261L9.26524 3.40516L9.37121 3.73122L9.0938 3.52969L8.81636 3.73122L8.92236 3.40516L8.64493 3.20356H8.9878L9.0938 2.8775ZM10.1882 2.8775L10.2941 3.20356H10.637L10.3596 3.40516L10.4656 3.73122L10.1882 3.52969L9.91077 3.73122L10.0167 3.40516L9.73936 3.20356H10.0822L10.1882 2.8775ZM7.99939 1.73912L8.10533 2.06525H8.44824L8.17083 2.26678L8.27677 2.59291L7.99939 2.39137L7.72196 2.59291L7.82796 2.26678L7.55052 2.06525H7.89343L7.99939 1.73912ZM9.0938 1.73912L9.19977 2.06525H9.54261L9.26524 2.26678L9.37121 2.59291L9.0938 2.39137L8.81636 2.59291L8.92236 2.26678L8.64493 2.06525H8.9878L9.0938 1.73912ZM10.1882 1.73912L10.2941 2.06525H10.637L10.3596 2.26678L10.4656 2.59291L10.1882 2.39137L9.91077 2.59291L10.0167 2.26678L9.73936 2.06525H10.0822L10.1882 1.73912Z'
      fill='#F0F0F0'
    />
  </svg>
)

export const RuFlag: FlagIcon = (props) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M8 16a8 8 0 0 0 7.62-5.57H0.38A8 8 0 0 0 8 16Z' fill='#D80027' />
    <path
      d='M0.38 5.57A8 8 0 0 0 0 8c0 .85.13 1.67.38 2.43h15.24A8 8 0 0 0 16 8c0-.85-.13-1.67-.38-2.43H0.38Z'
      fill='#0052B4'
    />
    <path d='M8 0A8 8 0 0 0 0.38 5.57h15.24A8 8 0 0 0 8 0Z' fill='#F0F0F0' />
  </svg>
)

export const EnFlag: FlagIcon = (props) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_106_7092)'>
      <path
        d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z'
        fill='#012169'
      />
      <path
        d='M14.1642 2.90186L7.99996 6.60053L1.8357 2.90186C1.323 3.52183 0.906927 4.21571 0.601562 4.96L5.66823 8L0.601562 11.04C0.906693 11.7845 1.32259 12.4785 1.83516 13.0987L7.99996 9.39946L14.1648 13.0981C14.6773 12.478 15.0932 11.7839 15.3984 11.0395L10.3317 7.99946L15.3984 4.95946C15.093 4.21536 14.6769 3.52167 14.1642 2.90186Z'
        fill='white'
      />
      <path
        d='M1.59358 12.7771L8.77704 8.46666L14.8528 12.112C14.9905 11.8829 15.1167 11.6471 15.2309 11.4053L8.77758 7.53333L14.8528 3.88853C14.7145 3.65884 14.5657 3.43698 14.4064 3.22293L7.22238 7.53333L1.14664 3.88853C1.00975 4.1168 0.883887 4.35218 0.769043 4.59466L7.22238 8.46666L1.14664 12.112C1.28442 12.341 1.43358 12.563 1.59358 12.7771Z'
        fill='#C8102E'
      />
      <path
        d='M10 0.262403C8.68962 -0.0874677 7.31039 -0.0874677 6 0.262403V6H0.262403C-0.0874677 7.31039 -0.0874677 8.68962 0.262403 10H6V15.7376C7.31039 16.0875 8.68962 16.0875 10 15.7376V10H15.7376C16.0875 8.68962 16.0875 7.31039 15.7376 6H10V0.262403Z'
        fill='white'
      />
      <path
        d='M9.2 0.0997333C8.80307 0.0364541 8.40193 0.00311562 8 0C7.59807 0.00311562 7.19693 0.0364541 6.8 0.0997333V6.8H0.0997333C0.0364541 7.19693 0.00311562 7.59807 0 8C0.00311562 8.40193 0.0364541 8.80307 0.0997333 9.2H6.8V15.9003C7.19693 15.9635 7.59807 15.9969 8 16C8.40193 15.9969 8.80307 15.9635 9.2 15.9003V9.2H15.9003C15.9635 8.80307 15.9969 8.40193 16 8C15.9969 7.59807 15.9635 7.19693 15.9003 6.8H9.2V0.0997333Z'
        fill='#C8102E'
      />
    </g>
    <defs>
      <clipPath id='clip0_106_7092'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
